import "./index.css";

export const EntregasDevolucionesInstantaneos = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Matriz de control entregas-devoluciones instantaneos</h1>
      </div>
    </div>
  );
};
